import React from 'react';

const PageNotFound = (): JSX.Element => (
  <>
    You are not allowed to see this page.
  </>
);

PageNotFound.displayName = 'PageNotFound';

export default PageNotFound;
